import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config/config";

function ItemsTours() {
  const [items, setItems] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = { tj: 1, ru: 2, en: 3 };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(`${API_BASE_URL}/api/events/events-tours?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => setItems(response.data.entities || response.data))
      .catch((err) => console.error("Error fetching tours:", err));
  }, [i18n.language]);

  useEffect(() => {
    AOS.init({ duration: 1200, easing: "ease-in-out" });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [items]);

  const getLocalizedValue = (item, field) => {
    if (!item) return "";
    const map = { ru: "Ru", tj: "Tj", en: "En" };
    const suffix = map[i18n.language] || "Ru";
    return item[`${field}${suffix}`] || item[field] || "";
  };

  return (
    <Container
      fluid
      className="container py-5"
      style={{ background: "#f8f9fa" }}
    >
      <Container>
        <h3
          className="mb-4 text-center fw-bold"
          data-aos="fade-down"
          style={{ fontSize: "2rem", letterSpacing: "0.5px" }}
        >
          {t("discover.tours")}
        </h3>
        <Row>
          {items.length === 0 && (
            <p className="text-center text-muted">{t("NoAvailable")}</p>
          )}
          {items.map((item) => (
            <Col
              xs={12}
              md={6}
              lg={4}
              className="mb-4"
              key={item.id}
              data-aos="zoom-in"
            >
              <Card className="h-100 shadow-sm border-0 rounded-4 overflow-hidden">
                {item.image && (
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={getLocalizedValue(item, "title")}
                    style={{
                      maxHeight: "180px",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                    className="hover-scale"
                  />
                )}
                <Card.Body className="d-flex flex-column">
                  <Card.Title
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.3rem",
                      color: "#2c3e50",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: getLocalizedValue(item, "title"),
                    }}
                  />
                  <Card.Text
                    className="text-muted flex-grow-1"
                    style={{ fontSize: "0.875rem", lineHeight: "1.25rem" }}
                    dangerouslySetInnerHTML={{
                      __html: getLocalizedValue(item, "shortDesc"),
                    }}
                  />
                  <Button
                    as={Link}
                    to={`/tours/show/${item.id}`}
                    state={{ event: item }}
                    className="mt-2 px-3 py-2 fw-semibold"
                    style={{
                      backgroundColor: "#6D9273",
                      border: "none",
                      fontSize: "0.875rem",
                      transition: "background-color 0.3s",
                    }}
                  >
                    {t("More details")}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default ItemsTours;
